import { SddStatus } from '../../communication/customer/CustomerDueDiligenceApi'
import { SddStatusEvent, SddStatusEventType } from './SddStatusEvents'

export interface SddStatusState {
	status: SddStatus;
	loading: boolean;
	error?: string;
}

const INITIAL_STATE: SddStatusState = {
	status: SddStatus.REQUIRED,
	loading: false,
	error: undefined,
}

export const sddStatusReducer = (state: SddStatusState = INITIAL_STATE, action: SddStatusEvent): SddStatusState => {
	switch (action.type) {
	case SddStatusEventType.SDD_STATUS_FETCH_STARTED: {
		return { ...state, loading: true, error: undefined }
	}
	case SddStatusEventType.SDD_STATUS_RECEIVED: {
		return { ...state, status: action.payload, loading: false, error: undefined }
	}
	case SddStatusEventType.SDD_STATUS_FETCH_FAILED: {
		return { ...state, loading: false, error: action.payload }
	}
	default:
		return state
	}
}
